export const getSessionId = () => {
  let id = sessionStorage.getItem("alkyrvis_sid");
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `s-${Date.now()}`;
    sessionStorage.setItem("alkyrvis_sid", id);
  }
  return id;
};
